import * as React from 'react';
import { STANDARD_SWIPER_OPTIONS } from '../../../../settings';
import './styles.css';
import { ICustomSwiperNavigationRef, CustomSwiper } from '../../../../components/CustomSwiper';

interface IStandardCarouselProps {
  children: React.ReactElement[];
  navRef: ICustomSwiperNavigationRef;
}

export function StandardCarousel({ children, navRef }: IStandardCarouselProps) {
  return (
    <CustomSwiper className="standard-plus-carousel" {...STANDARD_SWIPER_OPTIONS} navRef={navRef}>
      {children}
    </CustomSwiper>
  );
}
